import React from 'react';

import { ContactItems } from './contactItems';
import { HeroComponent } from '@modules/services/shared/HeroComponent';
import { cx } from '@emotion/css';

import styles from './contactUsView.module.scss';

export const ContactUsView = () => {
  return (
    <>
      <HeroComponent
        imageAlt="Contact us banner image"
        title="Contact Us"
        imageLink="/images/contact-us/contact-us.webp"
        styles={styles}
      />
      <section className={styles.services}>
        <div className={styles.services_card_block}>
          <div className={styles.container}>
            <div className={styles.inner_section}>
              <div className={cx(styles.heading_wrapers, styles.root)}>
                <h1 className={cx(styles.site_title, styles.h1)}>
                  Connect with Our Team
                </h1>
                <p className={cx(styles.heading_wrapers_content, styles.p)}>
                  Drop us a line and let's turn your questions into solutions.
                  We're ready to chat, listen, and help you move forward.
                </p>
              </div>
              <ContactItems styles={styles} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
